var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./CohortInsights.module.scss";
import { BubbleChart } from "../BubbleChart/BubbleChart";
import { useGetBubbleBuckets } from "../../store/api/core";
import React, { useContext } from "react";
import { FilterContext } from "../../providers/FilterProvider";
import { SavilleSwiftAptitudeSkills, SwiftSkill, Tab, } from "../../common/cohortHelpers";
import { getColorDecider } from "../../common/action";
import Dropdown from "../Dropdown";
import { ButtonVariant } from "../Button/Button";
export var CohortInsightsBubbles = function (props) {
    var _a, _b;
    var getFilters = useContext(FilterContext).getFilters;
    var shouldShowPopupScoreCircleBorder = (_a = props.showPopupScoreCircleBorder) !== null && _a !== void 0 ? _a : [Tab.SavilleWave, Tab.ImmersiveMeta, Tab.SavilleSwiftAptitude].includes(props.category);
    var popupBorderFunctor = shouldShowPopupScoreCircleBorder
        ? function (score, colorDescriptions) {
            var lowestScoreBand = __spreadArray([], colorDescriptions, true).sort(function (a, b) { return a.low - b.low; })[0];
            if (!lowestScoreBand) {
                return "transparent";
            }
            var decideBorder = getColorDecider(colorDescriptions);
            return score < lowestScoreBand.high
                ? decideBorder(score).border || "transparent"
                : "transparent";
        }
        : undefined;
    var response = useGetBubbleBuckets({
        filters: getFilters(),
        reportId: props.reportId,
        category: props.category || Tab.CBI,
        skill: props.skill,
        skillGroup: props.skillGroup,
    });
    var data = (((_b = response.data) === null || _b === void 0 ? void 0 : _b.map(function (leaderData) {
        var _a;
        return ({
            x: Number(leaderData[props.keyedLabels.x.key]),
            y: Number(leaderData[props.keyedLabels.y.key]),
            contains: leaderData.leaders,
            count: isNaN(Number(leaderData.leaderCount))
                ? ((_a = leaderData === null || leaderData === void 0 ? void 0 : leaderData.leaders) === null || _a === void 0 ? void 0 : _a.length) || 0
                : leaderData.leaderCount,
        });
    })) || []).map(function (_a) {
        var x = _a.x, y = _a.y, contains = _a.contains, count = _a.count;
        return ({
            contains: contains,
            count: count,
            x: x > 0 ? x : 1,
            y: y > 0 ? y : 1,
        });
    });
    if (data.length < 1) {
        return _jsx(_Fragment, {});
    }
    return (_jsx(BubbleChart, { identification: "cohort-bubbles", data: data, axisFormatter: props.axisFormatter, colorDescriptions: props.colorDescriptions, availableLabels: props.availableLabels, gridPositions: props.gridPositions, bubbleScoreRounder: props.bubbleScoreRounder, keyedLabels: props.keyedLabels, showAxisBarBorders: props.showAxisBarBorders, popupBorderFunctor: popupBorderFunctor }));
};
export var SelectableSkillCohortInsightsBubbles = function (props) {
    var _a = React.useState(SwiftSkill.Verbal), skillGroup = _a[0], setSkillGroup = _a[1];
    var skillGroups = __spreadArray([], SavilleSwiftAptitudeSkills, true).filter(function (skill) { return skill !== SwiftSkill.Overall; });
    return (_jsxs(_Fragment, { children: [_jsx("span", __assign({ className: styles.skillSwitcher }, { children: _jsx(Dropdown, { initial: skillGroup, buttonOverrideProps: { variant: ButtonVariant.Secondary }, options: skillGroups.map(function (skillGroup) { return ({
                        label: skillGroup,
                        value: skillGroup,
                        onChange: function () { return setSkillGroup(skillGroup); },
                    }); }), optionSorter: function (_a, _b) {
                        var a = _a.label;
                        var b = _b.label;
                        return b.localeCompare(a);
                    } }) })), _jsx(CohortInsightsBubbles, __assign({}, props, { skillGroup: skillGroup, showAxisBarBorders: true, axisFormatter: function (value) { return ({
                    label: "".concat(value.toFixed(0)),
                    offset: 6,
                }); } }))] }));
};
